import Chip from '@mui/material/Chip';

import { useActions } from '../actions/ActionsProvider';

import { saveNote } from './save-state';
import { useUnsavedCount } from './unsaved';

/**
 * What the screen says about the reviewer's work — GEN-55.
 *
 * A chip rather than an `Alert`: this is on screen at all times, including when everything
 * is fine, and four permanent alert bars is the shape that trains people to stop reading
 * them. The refusals still go to the action feed, where they can be dismissed.
 */
export function SaveState() {
  const { actions } = useActions();
  const unsaved = useUnsavedCount();
  const note = saveNote(actions, unsaved);

  return (
    <Chip
      size="small"
      variant={note.severity === 'success' ? 'outlined' : 'filled'}
      color={note.severity}
      label={note.message}
      // The state changes without anything moving on screen, which is exactly the change a
      // screen reader is otherwise never told about.
      role="status"
    />
  );
}
